var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Caution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 11L9.52 61h57L38 11zm-2 16a2 2 0 014 0v16a2 2 0 01-4 0V27zm2 29a3 3 0 110-5.999A3 3 0 0138 56z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Caution.34eaeafe.svg";
export { SvgJ2Caution as ReactComponent };